import React, {useState, useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {FaWhatsapp, FaTelegram, FaChevronDown, FaTimes} from "react-icons/fa";
import "./Header.css";
import LanguageSwitcher from "../../../components/ui/LanguageSwitcher/LanguageSwitcher.jsx";
import {motion, AnimatePresence} from "framer-motion";
import {smoothScrollTo} from "../../../utils/smoothScroll.js";
import Logo from "../../../assets/logo.svg";
import Logo2 from "./logo2.svg";

const Header = () => {
    const {t} = useTranslation();
    const [isScrolled, setIsScrolled] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const servicesRef = useRef(null);
    const navigate = useNavigate();
    // Обработчик скролла для изменения фона
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 500);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Закрытие выпадающего списка при клике вне области
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (servicesRef.current && !servicesRef.current.contains(event.target)) {
                setIsServicesOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (<>
        <AnimatePresence>
            {menuOpen && (<motion.div
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}
                className="fixed inset-0 bg-black/70 backdrop-blur-md bg-opacity-50 z-40 lg:hidden"
                onClick={() => setMenuOpen(false)}
            />)}
        </AnimatePresence>

        <header
            className={`header fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? "bg-[#ede8e1]/80 text-gray-900 shadow-md backdrop-blur-xl" : "bg-white/20 text-gray-300 backdrop-blur-sm"}`}
        >
            <div className="container  mx-auto py-1 flex items-center justify-between">
                {/* Навигация для десктопа */}
                <a
                    href="/"
                    // onClick={(e) => {
                    //     e.preventDefault();
                    //     navigate(`/${i18n.language}`);
                    //     window.scrollTo({top: 0, behavior: "smooth"});
                    // }}
                >
                    <img loading="lazy" src={isScrolled ? Logo2 : Logo} alt="Logo" className="h-14"/>
                </a>
                <nav className="hidden lg:flex text-lg items-center space-x-6">
                    <a
                        href="#about"
                        onClick={(e) => {
                            e.preventDefault();
                            smoothScrollTo("about");
                        }}
                        className="hover:text-white transition-colors cursor-pointer"
                    >
                        {t("header.about")}
                    </a>


                    <a
                        className="hover:text-white transition-colors cursor-pointer"
                        onClick={(e) => {
                            e.preventDefault();
                            setIsServicesOpen(false);
                            smoothScrollTo("cultural");
                        }}
                    >
                        {t("services.culture")}
                    </a>
                    <a
                        className="hover:text-white transition-colors cursor-pointer"
                        onClick={(e) => {
                            e.preventDefault();
                            setIsServicesOpen(false);
                            smoothScrollTo("outdoor");
                        }}
                    >
                        {t("services.nature")}
                    </a>
                    <a
                        className="hover:text-white transition-colors cursor-pointer"
                        onClick={(e) => {
                            e.preventDefault();
                            setIsServicesOpen(false);
                            smoothScrollTo("extreme");
                        }}
                    >
                        {t("services.extreme")}
                    </a>
                </nav>

                {/* Контакты и соцсети для десктопа */}
                <div className="hidden lg:flex items-center space-x-6">
                    <LanguageSwitcher/>
                    <a
                        href="tel:+7 916 407 7144"
                        className="font-medium text-xl hover:text-white transition-colors"
                    >
                        +7 916 407 7144
                    </a>

                    <div className="flex space-x-4">
                        <a
                            href="https://wa.me/79164077144"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-white transition-colors"
                            aria-label="WhatsApp"
                        >
                            <FaWhatsapp className="text-xl w-8 h-8"/>
                        </a>
                        <a
                            href="https://t.me/premium_tourism"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-white transition-colors"
                            aria-label="Telegram"
                        >
                            <FaTelegram className="text-xl w-8 h-8"/>
                        </a>
                    </div>
                </div>

                {/* Мобильная версия */}
                <div className="header__social-media lg:hidden">
                    <div className="flex items-center space-x-4">
                        {/* Телефон */}
                        <a href="tel:+79164077144">
                            <p className="phone footer__phone text-sm">
                                +7 (916) 407-71-44
                            </p>
                        </a>
                        {/* Telegram */}
                        <a
                            href="https://t.me/premium_tourism"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-white transition-colors"
                        >
                            <FaTelegram className="text-xl w-6 h-6"/>
                        </a>
                        {/* WhatsApp */}
                        <a
                            href="https://wa.me/79164077144"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-white transition-colors"
                        >
                            <FaWhatsapp className="text-xl w-6 h-6"/>
                        </a>
                        <button onClick={() => setMenuOpen(true)} aria-label="Open menu">
                            <svg
                                className="w-8 h-8"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </header>

        {/* Мобильное меню */}
        <AnimatePresence>
            {menuOpen && (<motion.div
                initial={{x: "100%"}}
                animate={{x: 0}}
                exit={{x: "100%"}}
                transition={{type: "tween", duration: 0.3}}
                className="fixed top-0 right-0 h-full w-64 bg-white/95 backdrop-blur-sm text-gray-900 z-60 shadow-xl lg:hidden overflow-y-auto"
            >
                <div className="p-4 flex justify-end">
                    <button
                        onClick={() => setMenuOpen(false)}
                        aria-label="Close menu"
                    >
                        <FaTimes className="text-xl"/>
                    </button>
                </div>
                <nav className="flex flex-col p-4 space-y-4">
                    <div className="py-2 border-b border-gray-200">
                        <div className="mt-2 ml-4 space-y-2">
                            <a
                                className="block py-1 cursor-pointer text-lg"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setMenuOpen(false);
                                    setIsServicesOpen(false);
                                    setTimeout(() => {
                                        smoothScrollTo("cultural");
                                    }, 300);
                                }}
                            >
                                {t("services.culture")}
                            </a>
                            <a
                                className="block py-1 cursor-pointer text-lg"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setMenuOpen(false);
                                    setIsServicesOpen(false);
                                    setTimeout(() => {
                                        smoothScrollTo("outdoor");
                                    }, 300);
                                }}
                            >
                                {t("services.nature")}
                            </a>
                            <a
                                className="block py-1 cursor-pointer text-lg"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setMenuOpen(false);
                                    setIsServicesOpen(false);
                                    setTimeout(() => {
                                        smoothScrollTo("extreme");
                                    }, 300);
                                }}
                            >
                                {t("services.extreme")}
                            </a>
                        </div>
                    </div>
                    <a
                        className="py-2 ml-4 border-b border-gray-200 cursor-pointer text-lg"
                        onClick={(e) => {
                            e.preventDefault();
                            setMenuOpen(false);
                            setTimeout(() => {
                                smoothScrollTo("about");
                            }, 300);
                        }}
                    >
                        {t("header.about")}
                    </a>
                    <a
                        href="tel:+79164077144"
                        className="py-2 border-b border-gray-200 font-medium text-lg"
                    >
                        +7 (916) 407-71-44
                    </a>

                    <div className="flex space-x-4 pt-2">
                        <a
                            href="https://wa.me/79164077144"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-gray-600 transition-colors"
                            aria-label="WhatsApp"
                        >
                            <FaWhatsapp className="text-2xl"/>
                        </a>
                        <a
                            href="https://t.me/premium_tourism"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-gray-600 transition-colors"
                            aria-label="Telegram"
                        >
                            <FaTelegram className="text-2xl"/>
                        </a>
                    </div>
                    <div className="pt-4">
                        <LanguageSwitcher/>
                    </div>
                </nav>
            </motion.div>)}
        </AnimatePresence>
    </>);
};

export default Header;
